const getPageName = document.querySelector('#container').classList[0]
export {getPageName}